
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class SingularityCanvasButton extends Vue {
  @Prop({ type: String, required: true })
  icon!: string;

  @Prop({ type: String, required: true })
  text!: string;

  @Prop({ type: String, default: null })
  size!: "small" | "large";

  get classes() {
    return {
      "singularity-canvas-button": true,
      "singularity-canvas-button--small": this.size === "small",
      "singularity-canvas-button--large": this.size === "large"
    };
  }
}
